import React, {Component} from "react"
import {Bar, BlueProgressBar} from "./styled"

interface Props {
  completedSteps: Number
}

class ProgressBar extends Component<Props> {
  render() {
    const {completedSteps} = this.props
    const width = Math.round(completedSteps / 12 * 100)

    return (
      <Bar>
        <BlueProgressBar width={width}  />
      </Bar>
    )
  }
}

export default ProgressBar
